import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { PageContext } from 'hooks/shared/usePageContext.types';
import { CandidateCardHeaderStyles } from './types';

const styles = {
  root: css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 24px;
    width: 100%;
    height: 100%;
    gap: 12px;
  `,
  actionButtonsWrapper: ({ theme }) => css`
    width: fit-content;
    border: solid 1px ${theme.colors.neutral.variant[20]};
    border-radius: 8px;
    padding: 4px;
    gap: 11px;
    background-color: ${theme.colors.neutral.variant[0]};
  `,
  divider: ({ theme }) => css`
    display: flex;
    width: 1px;
    height: 24px;
    background-color: ${theme.colors.neutral.variant[30]};
  `,
  alignRows: ({ props: { pageContext } = {} }) => css`
    display: flex;
    flex-flow: ${pageContext === PageContext.CentralInbox ? 'column-reverse' : 'column'};
    gap: 12px;
  `,
  row: () => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    width: 100%;
  `,
  headerName: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  robinVerified: css`
    padding-top: 2px;
  `,
  pill: css`
    width: 22px;
  `,
  tooltip: css`
    text-align: center;
  `,
} satisfies Styles<CandidateCardHeaderStyles>;

export const useStyles = withStyles(styles);
